/**
 * @generated SignedSource<<1d158c24ef9610973a62a9e83e15f4de>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type InfectoLeaveFeedbackInput = {
  body: string;
  clientMutationId?: string | null;
  nodeId?: string | null;
  screen?: string | null;
};
export type FeedbackButtonV2_LeaveFeedbackMutation$variables = {
  input: InfectoLeaveFeedbackInput;
};
export type FeedbackButtonV2_LeaveFeedbackMutation$data = {
  readonly FeedbackV2: {
    readonly infectoLeaveFeedback: {
      readonly clientMutationId: string | null;
    } | null;
  };
};
export type FeedbackButtonV2_LeaveFeedbackMutation = {
  response: FeedbackButtonV2_LeaveFeedbackMutation$data;
  variables: FeedbackButtonV2_LeaveFeedbackMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "FeedbackV2Mutations",
    "kind": "LinkedField",
    "name": "FeedbackV2",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "InfectoLeaveFeedbackPayload",
        "kind": "LinkedField",
        "name": "infectoLeaveFeedback",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "clientMutationId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FeedbackButtonV2_LeaveFeedbackMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FeedbackButtonV2_LeaveFeedbackMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c02cbf54de78226f8e38fbfe3e32f006",
    "id": null,
    "metadata": {},
    "name": "FeedbackButtonV2_LeaveFeedbackMutation",
    "operationKind": "mutation",
    "text": "mutation FeedbackButtonV2_LeaveFeedbackMutation(\n  $input: InfectoLeaveFeedbackInput!\n) {\n  FeedbackV2 {\n    infectoLeaveFeedback(input: $input) {\n      clientMutationId\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3dc45b4087629c379323d8b28fdf9e37";

export default node;
